import React from "react";
import { motion } from "framer-motion";
import useSeo from "@/hooks/useSeo";
import Breadcrumb from "@/components/Breadcrumb";
import PageHeader from "@/components/PageHeader";
import About from "@/components/About";

const photos = [
  { src: "/team/tim-antwerpen.webp", alt: "Tim Roosendaal in Antwerpen", caption: "Antwerpen · onderweg voor klanten", span: "col-span-6 lg:col-span-3", aspect: "aspect-[3/4]", rotate: "lg:-rotate-1" },
  { src: "/team/tim-phone-wide.webp", alt: "Tim Roosendaal beantwoordt een klantbericht op zijn telefoon", caption: "Altijd aan · reactie binnen 24u", span: "col-span-12 lg:col-span-6", aspect: "aspect-[16/10]", rotate: "" },
  { src: "/team/tim-dinant.webp", alt: "Tim Roosendaal in Dinant", caption: "Dinant · tussen twee sessies door", span: "col-span-6 lg:col-span-3", aspect: "aspect-[3/4]", rotate: "lg:rotate-1" },
];

const OverOnsPage = () => {
  useSeo({
    title: "Over Ons | Tim Roosendaal & Het Verhaal van UPPIT",
    description:
      "Maak kennis met Tim Roosendaal en UPPIT — een boutique bureau dat MKB en ZZP'ers helpt structureel groeien met AI, SEO en webdesign.",
    path: "/over-ons",
    ogSlug: "page/over-ons",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Tim Roosendaal",
      jobTitle: "Founder & Online Marketing Strateeg",
      worksFor: {
        "@type": "Organization",
        name: "UPPIT",
        url: "https://uppit.nl",
      },
      sameAs: ["https://www.linkedin.com/in/eigenwijzetim/"],
    },
  });

  return (
    <main data-testid="overons-page" className="bg-ivory">
      <section className="pt-32 max-w-[1400px] mx-auto px-6 lg:px-12">
        <Breadcrumb
          items={[
            { label: "Home", href: "/" },
            { label: "Over ons", href: "/over-ons" },
          ]}
        />
        <PageHeader
          kicker="Over ons · Studio"
          italic="Een klein team."
          bold="Grote obsessie."
          lede="UPPIT is een studio-bureau uit Nederland, opgericht door Tim Roosendaal. We werken direct — geen accountmanagers, geen sjablonen, geen bureau-poëzie. Wel: eerlijk werk voor MKB en ZZP."
        />
      </section>
      <section data-testid="overons-photo-strip" className="max-w-[1400px] mx-auto px-6 lg:px-12 mb-8 lg:mb-14">
        <div className="grid grid-cols-12 gap-4 lg:gap-6 items-end">
          {photos.map((p, i) => (
            <motion.figure
              key={p.src}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`${p.span} ${p.rotate}`}
            >
              <div className={`${p.aspect} rounded-[1.25rem] overflow-hidden bg-obsidian-800 shadow-card-lift`}>
                <img src={p.src} alt={p.alt} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <figcaption className="mt-3 font-mono text-[10px] uppercase tracking-[0.22em] text-coal/45">
                {p.caption}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </section>
      <About />
    </main>
  );
};

export default OverOnsPage;
